import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { NavLink as Link, withRouter } from 'react-router-dom';
import config from 'config';
import ListManagementInfo from 'app/components/ListManagementInfo';
import LeaveMessagePopup from 'app/AccountNew/modals/LeaveMessage';
import { getLeadAutomatorPlanDetails, getPlansTypeAPI } from 'data/user/actions';
import { selectUserId, selectPlanDetails, isLegacyAccountPlan } from 'data/user/selectors';
import { getConnectLabel, isLaAvailable } from 'utils/brand';

import css from './style.scss';


class ListAutomatorPopover extends PureComponent {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleLearnMoreClick = this.handleLearnMoreClick.bind(this);
  }
 componentDidMount() {
    const { userId, getLeadAutomatorPlanDetails,getPlansTypeAPI } = this.props;
    if (userId) {
      getLeadAutomatorPlanDetails(userId);
      getPlansTypeAPI(userId);
    }
  }

  handleClick(ev) {
    const { checkSavedProperty } = this.props;
    const { target: form } = ev;
    const { constants: { API: { BASE_URL } } } = config;

    ev.preventDefault();
    ev.stopPropagation();

    checkSavedProperty((id) => {
      form.action = `${BASE_URL}/resource/auth/ps4/user/properties/${id}/bluebook/directaccess/url?redirect=true`;
      form.submit();
    });
  }

  handleLearnMoreClick(ev) {
      const { isLegacyAccount, leaveMessagePopup, history } = this.props;
      if (!isLegacyAccount) {
        return;
      }

      ev.preventDefault();
      leaveMessagePopup({
        title: "Upgrade Your Plan",
        message: "To access PropStream Connect, please upgrade your current plan to Essentials, Pro, or Elite.",
        autoWidth: false,
        yesLable: "Upgrade Plan",
        cancelLable: "Cancel",
        yesRedirect: () => history.push("/accountnew/plan"),
      });
    }

  render() {
    const { className, openListManagementInfo, isLegacyAccount } = this.props;
    // Legacy accounts can't purchase the PS Connect add-on directly; send them to plan upgrade instead.
    const learnMoreTo = isLegacyAccount ? "/accountnew/plan" : "/accountnew/leadautomator";
    return !isLaAvailable() ? null : (
      <div className={classNames(css.lmOverlay, className)}>
        <div className={classNames(css.lmUpgrade)}>
          <p className={css.infoText}>Additional Filtering Requires {getConnectLabel()}</p>
            <Link 
              to={learnMoreTo}
              className={css.link}
              style={  {}}
              onClick={this.handleLearnMoreClick}
            >
                Learn More
            </Link>
        </div>
      </div>
    );
  }
}

ListAutomatorPopover.propTypes = {
  className: PropTypes.string,
};

export default withRouter(connect(state => ({
    userId: selectUserId(state),
    isLegacyAccount: isLegacyAccountPlan(state)
  }), {
      openListManagementInfo: ListManagementInfo.open,
      getLeadAutomatorPlanDetails,
      getPlansTypeAPI,
      leaveMessagePopup: LeaveMessagePopup.open
    }
)(ListAutomatorPopover));
